import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <a
          href="https://www.bosscarsoft.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          BossCarSoft
        </a>
        &copy; 2018 - 2023 v.nk.1.3.80 2026-07-21 12:41
        <span className="float-right">
          Powered by
          <a
            href="http://www.appxar.co"
            rel="noopener noreferrer"
            target="_blank"
          >
            &nbsp;Apzar Solution co.,ltd.
          </a>
        </span>
      </footer>
    );
  }
}

export default Footer;
